
const state = {
  removedProduct:[],// 已删除的产品
}
const mutations = {
  SET_REMOVEDPRODUCT: (state, REMOVEDPRODUCT) => {
    state.removedProduct = REMOVEDPRODUCT;
    sessionStorage.REMOVEDPRODUCT = REMOVEDPRODUCT;
  },
}

const actions = {

}
export default {
  namespaced: false,
  state,
  mutations,
}
